<template>
<!-- 蛋壳注册 合作页 type=1-->
  <div class="register">
    <div class="bg">
      <div class="container">
        <div class="phoneNum">
          <div class="textbg">
            <Prompt :promptInfo="promptInfo" v-show="isPrompt"></Prompt>
            <img src="../assets/images/cooperation/textbg.png" alt>
            <input type="text" placeholder="请输入手机号" v-model="phone">
          </div>
        </div>

        <div class="password">
          <img src="../assets/images/cooperation/textbg.png" alt>
          <input type="password" placeholder="请设置密码" v-model="password" maxlength="18">
           <div class="code">
            <img src="../assets/images/cooperation/hqyz.png" alt>
            <div class="codeMocen" @click="getCode" id="codeMocen"  ></div>
          </div>
        </div>
        <div class="loginCode">
          <img src="../assets/images/cooperation/textbg.png" alt>
          <input type="text" placeholder="请输入验证码" v-model="code">
        </div>
        <!-- 隐藏输入框 -->
        <div class="geetest_form">
          <input type="hidden" name="geetest_challenge" value>
          <input type="hidden" name="geetest_validate" value>
          <input type="hidden" name="geetest_seccode" value>
        </div>
        <!-- 注册 -->
        <div class="register">
          <img src="../assets/images/cooperation/btn1.png" alt>
          <div class="mocen" @click="register" ></div>
        </div>
        <div class="validation" id="validation">
          <div id="area"></div>
        </div>
      </div>
       <!-- 介绍 -->
        <div class="introduce">
          <p class="title">活动说明</p>
          <p class="item">1. 在本页输入手机号码并成功登录后，将获得专属礼包。</p>
          <p class="item">2.专属礼包需要在下载“我是谜”app，安装并登录后使用。</p>
          <p class="item">3.老用户无法参与本活动。</p>
          <p class="item">4. 最终解释权归上海吾声网络科技有限公司所有。</p>
          <p class="item">5.客服咨询电话:13248228667</p>

        </div>
      <!-- 礼物展示 -->
      <div class="Giftcontainer" v-show="isShow">
        <div class="gift">
          <img src="../assets/images/cooperation/gxhdbg.png" alt>
          <div class="gifts_container" @click="share">
          </div>
          <!-- <ul class="gift_container">
            template 标签创建虚拟dom 
            <template v-for="(item,index) in prizeList">
              <li class="gifts" v-if="index < 2" :key="index">
              <div class="gifts_img">
                <img :src="item.itemImg" alt>
              </div>
              <p class="gifts_name">{{item.prizeName}}</p>
            </li>
            </template>
          </ul>
          <div class="btn">
            <img src="../assets/images/cooperation/download.png" alt>
          </div>
          <div class="mocen" @click="share"></div> -->
        </div>
      </div>
    </div>
    <Motial :title="title" :browser="browser" :direct="direct" v-show="isMotial"></Motial>
  </div>
</template>
<script>
import axios from "axios";
import {appUrlAndroid,appUrlIOS}  from '../assets/js/base64'
//极验js
import "../assets/js/gt.js";
import Prompt from "../component/Prompt";
import Motial from "../component/Motial";
export default {
  data() {
    return {
      phone: "",
      code: "",
      password: "",
      isShow: false,
      promptInfo: "",
      isPrompt: false,
      title: "我是谜app打开方式",
      browser: "1. 点击右上角[...]",
      direct: "2. 选择[在浏览器中打开]",
      isMotial: false,
      captchaObj: "",
      platform: "",
      prizeList: [],
     
    };
  },
  components: {
    Prompt,
    Motial
  },
  created() {
    document.getElementsByTagName("title")[0].innerText = "我是谜";
    // 判断手机系统 苹果 或 安卓
    var u = navigator.userAgent,
      app = navigator.appVersion;
    this.isAndroid = u.indexOf("Android") > -1 || u.indexOf("Linux") > -1;
    this.isiOS = !!u.match(/\(i[^;]+;( U;)? CPU.+Mac OS X/);
    if (this.isAndroid) {
      this.platform = 1;
    } else if (this.isiOS) {
      this.platform = 2;
    } else {
      this.platform = 1;
    }
    window.scrollTo(0,0)
    //判断是否在微信浏览器中
      // var ua = navigator.userAgent.toLowerCase();
      // if (
      //   ua.match(/MicroMessenger/i) == "micromessenger" ||
      //   ua.match(/QQ/i) == "qq"
      // ) 
      //   this.isMotial = true;
      
      }
  ,
  methods: {
    //注册
    register() {
      if (this.phone == "" || this.password == "" || this.loginCode == "") {
        this.isPrompt = true;
        this.promptInfo = "请输入正确的手机号/密码/验证码";
      } else {
        axios({
          url:this.$interfaces.getUserWebRegister,
          method: "post",
          dataType: "json",
          data: {
            phoneNumber: this.phone,
            smsCode: this.code,
            password: this.password,
            platform: this.platform,
            type:1
          }
        })
          .then(res => {
            if (res.data.code !== 200 || res.data.code === 100010) {
              this.isPrompt = true;
              this.promptInfo ="请输入正确的验证码哦";
            } else {
              this.isShow = true;
              this.prizeList = res.data.data.prizeList
              // this.prizeList = res.data.data.prizeList.slice(0,2);
            }
          })
          .catch(err => {
            console.log(err);
          });
      }
    },
    //v2
    share(){
         this.baseUrl='https://a.app.qq.com/o/simple.jsp?pkgname=com.wzf.fan'
          if (this.isAndroid) {
             window.location.href = this.baseUrl+`&android_schema=${appUrlAndroid( "100000")}`;
           } else if (this.isiOS) {
            let ua = navigator.userAgent.toLowerCase();
              if(ua.match(/QQ/i) == "qq"){
                  this.isMotial = true;
              }else{
                 window.location.href = appUrlIOS('100000');
              }
           }else{
                window.location.href = 'http://share.mvoicer.com/#/open'
          }
    },
    //v1
    // share() {
    //   var ua = navigator.userAgent.toLowerCase();
    //   if (
    //     ua.match(/MicroMessenger/i) == "micromessenger" ||
    //     ua.match(/QQ/i) == "qq"
    //   ) {
    //     this.isMotial = true;
    //   } else {
    //     window.location.href = "mvoicerwsm://"; //ios
    //     window.location.href = "mvoicerwsm://openapp"; //安卓
    //     //记录唤醒时间
    //     var openTime = +new Date();
    //     window.setTimeout(function() {
    //       if (+new Date() - openTime > 1000) {
    //         window.location.href = "https://share.mvoicer.com/#/open";
    //       }
    //     }, 1500);
    //   }
    // },
    // 交互事件
    getCode() {
        this.isPrompt = false;
        axios({
          url: this.$interfaces.getCode,
          method: "get",
          dataType: "json"
        })
          .then(res => {
              window.scrollTo(0,0)
            initGeetest(
              {
                // 以下配置参数来自服务端 SDK
                gt: res.data.data.gt,
                challenge: res.data.data.challenge,
                offline: !res.data.data.success,
                new_captcha: true,
                lang: "zh-cn",
                product: "bind",
                area: "#area", // **必填参数**
                next_width: "17.5rem",
                bg_color: "black"
              },
              captchaObj => {
                captchaObj.onReady(() => {
                  let phoneNum = !/^(\+?0?86\-?)?1[345789]\d{9}$/.test(
                    this.phone
                  );
                  let regExp=/^(?=.*[A-Za-z])(?=.*\d)[A-Za-z\d]{8,}$/ //至少八个字符，至少一个字母和一个数字：
                  let password = !regExp.test(this.password);
                  if (phoneNum ){
                    this.isPrompt = true;
                    this.promptInfo = "请输入正确的手机号…";
                    this.phone = "";
                    setTimeout(()=>{
                      this.isPrompt=false
                    },2000)
                  }else if(password){
                     this.isPrompt = true;
                    this.promptInfo = "密码格式错误,请至少八个字符,含有字母和数字";
                    this.password=""
                    setTimeout(()=>{
                      this.isPrompt=false
                    },2000)
                  }else {
                    captchaObj.verify();
                    
                  }
                }),
                  captchaObj.onSuccess(() => {
                    let _this = this;
                    let result = captchaObj.getValidate();
                    window.scrollTo(0,0)
                    axios({
                      url: _this.$interfaces.getWebSmsCode,
                      method: "post",
                      dataType: "json",
                      data: {
                        geetest_seccode: result.geetest_seccode,
                        geetest_validate: result.geetest_validate,
                        geetest_challenge: result.geetest_challenge,
                        phoneNumber: _this.phone
                      }
                    })
                      .then(res => {
                        // console.log(res.data);
                        if (res.data.success === false) {
                          _this.isPrompt = true;
                          _this.promptInfo = res.data.message;
                          _this.phone = "";
                          _this.password = "";
                          setTimeout(()=>{
                          _this.isPrompt=false
                        },2000)
                        }
                        window.scrollTo(0,0)
                      })
                      .catch(err => {
                        console.log("失败:" + err);
                      });
                    // console.log(res);
                  });
                captchaObj.onError(err => {
                  // console.log(err);
                });
              }
            );
          })
          .catch(err => {
            console.log(err);
          });
      }
    }

};
</script>
<style scoped>
input{  
    background:none;  
    outline:none;  
    border:none;
}
span,p,input,button{
    list-style-type:none;
     /* iOS点击时出现阴影的css 解决办法 */
     -webkit-tap-highlight-color: rgba(0,0,0,0);
}
.register {
  width: 100%;
  height: 100%;
}
.register .bg {
  position: relative;
  height: 38.875rem;
  background: url("../assets/images/cooperation/wsm.jpg") no-repeat left top;
  background-size: cover;
  display: flex;
  justify-content: center;
}
/* 礼物展示 */
.register .bg .Giftcontainer {
  width: 100%;
  height: 38.875rem;
  position: absolute;
  top: 0;
  left: 0;
  background: rgba(0, 0, 0, 0.5);
  z-index: 999;
  display: flex;
  justify-content: center;
}
.register .bg .Giftcontainer .gift {
  position: absolute;
  top: 11.275rem;
  width: 14.075rem;
  height: 13.025rem;
  display: flex;
  justify-content: center;
  /* border:0.025rem solid red; */
}
.register .bg .Giftcontainer .gift img,
.register .bg .Giftcontainer .gift .btn img {
  width: 100%;
  height: 100%;
}
.register .bg .Giftcontainer .gift .gift_container {
  /* 第二版修改样式 */
  display: flex;
  justify-content: center;
  /* 第二版修改样式结束 */
  width: 7.95rem;
  height: 4.825rem;
  position: absolute;
  top: 3.375rem;
  left: 3.225rem;
}
/* 第二版修改样式 */
.register .bg .Giftcontainer .gift .gifts_container{
  background: url('../assets/images/cooperation/libao.png') no-repeat;
  position: absolute;
  bottom: 0.975rem;
  background-size: cover;
  width:9.975rem;
  height: 9.55rem;
  
}
/* 第二版修改版结束 */
.register .bg .Giftcontainer .gift .gift_container .gifts {
  width: 3.475rem;
  height: 4.825rem;
  /* border: 0.025rem solid red; */
  /* border-radius: 0.25rem; */
}
.register .bg .Giftcontainer .gift .gift_container .gifts .gifts_img {
  width: 3.475rem;
  height: 3.475rem;
  border: 1px solid #ccc;
  border-radius: 0.25rem;
  overflow: hidden;
}
.register .bg .Giftcontainer .gift .gift_container .gifts .gifts_name,
.register .bg .Giftcontainer .gift .gift_container .gifts .gifts_name {
  font-family: PingFang-SC-Bold;
  /* 正式字体 */
  /* font-size: 0.75rem; */
  /* 测试字体 */
  font-size: 0.625rem;
  font-weight: normal;
  font-stretch: normal;
  line-height: 1.25rem;
  letter-spacing: 0.075rem;
  color: #f86194;
  text-align: center;
}
.register .bg .Giftcontainer .gift .btn {
  width: 7.525rem; 
  height: 2.8rem;
  position: absolute;
  bottom: 0.975rem;
  left: 3.45rem;
}
.register .bg .Giftcontainer .gift .mocen {
  width: 7.525rem;
  height: 2.8rem;
  position: absolute;
  bottom: 0.975rem;
  left: 3.45rem;
  /* background:red; */
}
/* 礼物展示结束 */
.register .bg .container {
  position: absolute;
  top: 11.575rem;
  width: 16.05rem;
  height: 16.1rem;
  /* background:pink; */
}
.register .bg .container .phoneNum {
  height: 3.7rem;
}
.register .bg .container .phoneNum .textbg {
  position: absolute;
  top: 0;
  left: 0;
  width: 16.05rem;
  height: 3.7rem;
  display: flex;
  justify-content: center;
}
.register .bg .container .phoneNum .textbg input {
  position: absolute;
  height: 2rem;
  width: 8.625rem;
  border-radius: 0.3rem 0 0 0.3rem;
  margin-left: 0.375rem;
  line-height: 2rem;
  top: 0.85rem;
  left: 1rem;
  background-color: #48487a;
  border: none;
  font-family: NotoSansHans-Medium;
  font-size: 0.825rem;
  font-weight: normal;
  font-stretch: normal;
  color: white;
}
.register .bg .container .password  .code {
  width: 5.425rem;
  height: 1.975rem;
  position: absolute;
  right: 1rem;
  top: 0.875rem;
}
/* 安卓手机点击图片显示兼容性处理 */
.register .bg .container .password  .code .codeMocen {
  width: 5.425rem;
  height: 1.975rem;
  position: absolute;
  right: 0;
  top: 0;
  /* background:red; */
}
.register .bg .container .password {
  position: absolute;
  top: 4.275rem;
  left: 0;
  width: 16.05rem;
  height: 3.7rem;
}
.register .bg .container .loginCode {
  position: absolute;
  top: 8.55rem;
  left: 0;
  width: 16.05rem;
  height: 3.7rem;
}
.register .bg .container .loginCode input {
  position: absolute;
  height: 2rem;
  width: 8.625rem;
  border-radius: 0.3rem 0 0 0.3rem;
  margin-left: 0.375rem;
  line-height: 2rem;
  top: 0.85rem;
  left: 1rem;
  background-color: #48487a;
  border: none;
  font-family: NotoSansHans-Medium;
  font-size: 0.825rem;
  font-weight: normal;
  font-stretch: normal;
  color: white;
}
.register .bg .container .password input {
  position: absolute;
  height: 2rem;
  width: 8.625rem;
  border-radius: 0.3rem 0 0 0.3rem;
  margin-left: 0.375rem;
  line-height: 2rem;
  top: 0.85rem;
  left: 1rem;
  background-color: #48487a;
  border: none;
  font-family: NotoSansHans-Medium;
  font-size: 0.825rem;
  font-weight: normal;
  font-stretch: normal;
  color: white;
}
.register .bg .container .phoneNum .textbg img,
.register .bg .container .phoneNum .code img,
.register .bg .container .loginCode img,
.register .bg .container .password img,
.register .bg .container .register img {
  width: 100%;
  height: 100%;
}
.register .bg .container .register {
  width: 16.05rem;
  height: 3.275rem;
  position: absolute;
  left: 0;
  top: 12.825rem;
}
/* 安卓手机点击图片显示兼容性处理 */
.register .bg .container .register .mocen {
  width: 16.05rem;
  height: 3.275rem;
  position: absolute;
  left: 0;
  top: 0;
  /* background:red; */
}
.register .bg .introduce {
  position: absolute;
  bottom:3rem;
  left: 1.775rem;
  width: 17.075rem;
  height: 7.5rem;
}
.register .bg .introduce .title {
  font-family: NotoSansHans-Medium;
  font-size: 0.85rem;
  font-weight: normal;
  font-stretch: normal;
  line-height: 1.5rem;
  letter-spacing: 0.025rem;
  color: #ffffff;
  margin-bottom:0.25rem
}
.register .bg .introduce .item {
  font-family: NotoSansHans-Medium;
  font-size: 0.625rem;
  font-weight: normal;
  letter-spacing: 0.025rem;
  color: #ffffff;
  margin-bottom:0.25rem;
}
.bg .validation {
  position: absolute;
  top: 50%;
  left: 50%;
  /* width:7.5rem; */
  background: rgba(0, 0, 0, 0.8);
  /* height: 41.625rem;  */
}

</style>





// WEBPACK FOOTER //
// src/components/register.vue